import interceptor from '../common/interceptor';
import { APIPaths } from '../common/constants';
import { ApiResponse, FeaturePermissionMatrix } from '@/apis/types';

//Call for product type dd
export interface GetProductTypesResponse {
  data: {
    data: {
      is_success: boolean;
      status?: number;
      data?: unknown[];
      message?: string;
      page_count?: number;
    };
  };
}
export const GetProductTypes = (
  token: string
): Promise<GetProductTypesResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.product_type, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        // Pass the full error object instead of just error.response
        console.error('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};

export const GetProductTypesWithPaginationAndSearch = (
  page: number,
  search: string
): Promise<GetProductTypesResponse> => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams();
    if (page != null) {
      params.append('page', page.toString());
    }

    if (search) {
      params.append('search', search);
    }
    const url = `${APIPaths.product_type}?${params.toString()}`;
    interceptor
      .axiosGet('Get', url, undefined, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};
//Call for ccompany couriers
/** Team rows on company-courier payloads (from API `teams_detail`). */
export interface CourierTeamDetail {
  id: string;
  name: string;
  color?: string;
}

export interface CourierData {
  id: string;
  /** Courier (carrier) UUID from the API `courier` FK. */
  courier?: string;
  courier_id?: string;
  courier_name: string;
  /** Catalog provider key (e.g. `zlsim` for the ZoomLogi Simulator). */
  provider_key?: string | null;
  client_id: string;
  client_secret: string;
  credentials: {
    'API Key': string;
    'Secret Key': string;
  };
  /** Matches backend `CompanyCourier.status` (e.g. basic = Basic Tracking, linked = full API link). */
  status: 'linked' | 'unlinked' | 'basic' | 'pending' | 'error';
  teams: unknown[];
  /** Full team names/colors for UI; not stripped by default-team removal on `teams`. */
  teams_detail?: CourierTeamDetail[];
  permissions: FeaturePermissionMatrix;
}

interface CompanyCouriersData {
  company_id: string;
  couriers: CourierData[];
}

type GetCompanyCouriersResponse = ApiResponse<CompanyCouriersData>;

export const GetCompanyCouriers = (
  token: string
): Promise<GetCompanyCouriersResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.settingsCourier, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};

//Call for fetching designations
// Lightweight team option used in DDLs across the app
export interface TeamDDLOption {
  id: string;
  name: string;
  color?: string;
  company: string;
  permissions?: FeaturePermissionMatrix;
}

type GetTeamsDDLResponse = ApiResponse<TeamDDLOption[]>;

export const GetTeamsDDL = (
  token: string,
  featureName: string,
  search?: string
): Promise<GetTeamsDDLResponse> => {
  let url = `${APIPaths.teamsDDLForFeature}?feature=${featureName}`;
  if (search && search.trim().length > 0) {
    const encoded = encodeURIComponent(search.trim());
    url += `&search=${encoded}`;
  }
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};

export interface TeamLiteItem {
  id: string;
  name: string;
  [key: string]: unknown;
}

export interface GetTeamsLiteResponse {
  data: {
    data: {
      is_success?: boolean;
      data?: TeamLiteItem[];
      page_count?: number;
      total_count?: number;
      message?: string;
    };
  };
}

/**
 * Fetch teams for dropdowns with pagination and optional search.
 * GET /api/auth/teams/?lite=true
 */
export const GetTeamsLite = (
  page: number = 1,
  search?: string,
  pageSize: number = 20
): Promise<GetTeamsLiteResponse> => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      lite: 'true',
      page: String(page),
      ...(search ? { search: search.trim() } : {}),
      page_size: String(pageSize),
    });

    interceptor
      .axiosGet(
        'Get',
        `${APIPaths.teams}?${params.toString()}`,
        undefined,
        null
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching teams lite:', error?.response);
        reject(error?.response);
      });
  });
};
